import { render, staticRenderFns } from "./VarietiesReport.vue?vue&type=template&id=89c97e06&scoped=true&"
import script from "./VarietiesReport.vue?vue&type=script&lang=js&"
export * from "./VarietiesReport.vue?vue&type=script&lang=js&"
import style0 from "./VarietiesReport.vue?vue&type=style&index=0&id=89c97e06&scoped=true&lang=css&"
import style1 from "./VarietiesReport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c97e06",
  null
  
)

export default component.exports